import React, { useState, useRef, useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faDownload, faTimes, faExclamationTriangle, faSave } from '@fortawesome/free-solid-svg-icons';
import { validarOTP } from '../ValidarForm/ValidarForm'

const Modal = ({ show, showToast, fecharModal, salvarAlteracoesGrupo, titulo, setTitulo, imagem, setImagem, cor, setCor, abrirOpcoesIcone, isEditing, grupoId, getCookie }) => {
    const [matiz, setMatiz] = useState(0);
    const corTempRef = useRef(cor);
    const [showPermissoesGrupo, setShowPermissoesGrupo] = useState(false);
    
    const [luminosidade, setLuminosidade] = useState(5);

    // Atualiza o valor da cor final quando os sliders mudam
    useEffect(() => {
        const novaCorHSL = `hsl(${matiz}, 100%, ${luminosidade}%)`;
        setCor(novaCorHSL);
    }, [matiz, luminosidade]);

    useEffect(() => {
        if (show) {
            if (isEditing && cor && cor.startsWith("hsl")) {
                const matches = cor.match(/hsl\((\d+),\s*\d+%?,\s*(\d+)%?\)/i);
                if (matches) {
                    setMatiz(parseInt(matches[1], 10));
                    setLuminosidade(parseInt(matches[2], 10));
                }
            } else {
                // Se for novo grupo, define sliders no início
                setMatiz(0);
                setLuminosidade(5);
            }
        }
    }, [show]);

    if (!show) {
        return null;
    }

    // const colors = [
    //     { nome: 'vinhoEscuro', cor: '#3B1F2B' },
    //     { nome: 'rosaQueimadoEnvelhecido', cor: '#6D3A4D' },
    //     { nome: 'ameixaSuave', cor: '#9E5D6D' },
    //     { nome: 'azulPetroleoFosco', cor: '#1C2E4A' },
    //     { nome: 'azulAcinzentado', cor: '#3A4F6F' },
    //     { nome: 'azulPastelFrio', cor: '#6784A3' },
    //     { none: 'cinzaEscuroNeutro', cor: '#2A2A2E' },
    //     { nome: 'cinzaArroxeadoMedio', cor: '#4E4E58' },
    //     { nome: 'cinzaLilasSuave', cor: '#A9A9B2'},
    //     { nome: 'lavandaAcinzentado', cor: '#736C91'},
    //     { nome: 'lilasClaroPastel', cor: '#B7AFC9'},
    //     { nome: 'verdeOlivaAcinzentado', cor: '#5A7765'},
    //     { nome: 'laranjaQueimado', cor: '#B96F4B'},
    //     { nome: 'dourado', cor: '#C9A84E'},
    //     { nome: 'vermelhoQueimado', cor: '#8B3A3A'},
    //     { nome: 'roxoAmora', cor: '#593C6D'}
    // ];



    const colors = [
        { nome: 'rosa', cor: '#E83E8DCE' },
        { nome: 'verde', cor: '#50EC4E9C' },
        { nome: 'laranja', cor: '#FFA500' },
        { nome: 'roxo', cor: '#800080' },
        { nome: 'verdeAzulado', cor: '#76EDE98A' },
        { nome: 'vermelho', cor: '#FC030797' },
        { none: 'preto', cor: '#1F1F1F' },
        { nome: 'azul', cor: '#03A1FCBA' },
        { nome: 'verdeClaro', cor: '#7B862B'},
        { nome: 'azulClaro', cor: '#00FFFFaF'},
        { nome: 'azulEscuro', cor: '#1A799EBA'},
        { nome: 'cinza', cor: '#535151FC'}
    ];

    const handleTituloChange = (e) => {
        const value = e.target.value;
        if (value.length <= 50) {
            setTitulo(value);
        } else {
            showToast('O título pode ter no máximo 50 caracteres', 'warning');
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal modal-new-group"> 
                <header className="modal-header-criar">
                    {isEditing ?    
                        <h2>Editar grupo:</h2> 
                    :
                        <h2>Cadastrar novo grupo:</h2>
                    }
                    <button onClick={fecharModal} className="close-button">
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </header>
                <div className="icon-modal-body">
                    <div className="icon-form-group">
                        <label htmlFor="titulo">Título</label>
                        <input type="text"
                         className="input-titulo"
                         value={titulo}
                         onChange={handleTituloChange}
                         placeholder="Digite o título do grupo" 
                         required
                         maxLength={40}
                        />
                        <div className="character-counter">
                            {titulo.length}/40 caracteres
                        </div>
                    </div>
                    
                    <div className="form-group-row">
                        <div className="form-group half-width">
                            <label>Imagem (Ícone)</label>
                            <button className="btn btn-secondary" onClick={abrirOpcoesIcone}>
                                {imagem ? <FontAwesomeIcon icon={imagem.split(' ')} /> : 'Escolher Ícone'}
                            </button>
                        </div>

                        {isEditing && (
                            <div className="form-group half-width">
                            <label>Permissões do Grupo</label>
                            <button 
                                className="btn btn-secondary" 
                                onClick={() => setShowPermissoesGrupo(true)}
                                >
                                Gerenciar Permissões
                            </button>
                            <p className="info-text">
                                Usuários selecionados visualizarão TODOS os registros deste grupo
                            </p>
                        </div>
                        )}

                    </div>

                    <div className="icon-form-group">
                        <label>Cor</label>
                        <div className="seletor-cor-container">
                            <div className="seletor-slider">
                            <label>Matiz (cor base)</label>
                            <input
                                type="range"
                                min="0"
                                max="360"
                                value={matiz}
                                onChange={(e) => setMatiz(e.target.value)}
                                style={{
                                    background: `linear-gradient(to right, 
                                        hsl(0, 100%, 50%), 
                                        hsl(60, 100%, 50%), 
                                        hsl(120, 100%, 50%), 
                                        hsl(180, 100%, 50%), 
                                        hsl(240, 100%, 50%), 
                                        hsl(300, 100%, 50%), 
                                        hsl(360, 100%, 50%))`,
                                }}
                            />
                            </div>

                            <div className="seletor-slider">
                            <label>Luminosidade (clareza)</label>
                            <input
                                type="range"
                                min="5"
                                max="80"
                                value={luminosidade}
                                onChange={(e) => setLuminosidade(e.target.value)}
                                style={{
                                background: `linear-gradient(to right,
                                    hsl(${matiz}, 100%, 5%),
                                    hsl(${matiz}, 100%, 80%))`,
                                }}
                            />
                            </div>

                            <div
                                className="preview-cor"
                                style={{ backgroundColor: `hsl(${matiz}, 100%, ${luminosidade}%)` }}
                            />
                        </div>
                    </div>

                </div>
                <footer className="modal-footer">
                    <button className="btn btn-secondary" onClick={fecharModal}>Voltar</button>
                    <button className="btn btn-primary" onClick={salvarAlteracoesGrupo}>
                        {isEditing ? "Atualizar" : "Cadastrar"}
                    </button>
                </footer>
            </div>

            {showPermissoesGrupo && (
                <ModalPermissoesGrupo
                    show={showPermissoesGrupo}
                    fecharModal={() => setShowPermissoesGrupo(false)}
                    grupoId={grupoId}
                    getCookie={getCookie} // Você precisará passar essa prop
                    showToast={showToast}
                    isCreating={!isEditing}
                />
            )}
        </div>
    );
};

const ModalOpcoesIcone = ({ show, fecharModal, iconeSelecionado }) => {
    const icons = [
        'fas fa-radiation', 'fab fa-hotjar', 'fab fa-teamspeak', 'fab fa-aws',
        'fab fa-battle-net', 'fab fa-500px', 'fas fa-database', 'fab fa-microsoft',
        'fas fa-hand-rock', 'far fa-file-code', 'fas fa-fire-extinguisher', 'fas fa-sync-alt',
        'fas fa-chalkboard-teacher', 'fas fa-server', 'fas fa-file-invoice-dollar',
        'fab fa-git', 'fas fa-cart-plus', 'fab fa-ello', 'fab fa-ethereum',
        'far fa-gem', 'fab fa-dev', 'fab fa-btc', 'fas fa-tv', 'fab fa-bitbucket',
        'fab fa-creative-commons-nc', 'far fa-closed-captioning', 'fas fa-key', 'fab fa-contao',
        'fab fa-teamspeak', 'fas fa-car', 'fab fa-page4', 'fab fa-app-store-ios',
        'fas fa-robot', 'fas fa-mail-bulk', 'fab fa-nutritionix', 'fas fa-skull',
        'fas fa-user-secret', 'fab fa-wordpress-simple', 'fas fa-hat-wizard', 'fas fa-gamepad',
        'fas fa-funnel-dollar', 'fas fa-envelope-open-text', 'fas fa-search-location',
        'far fa-file-code', 'fas fa-hand-sparkles', 'fas fa-gavel', 'fas fa-virus',
        'fab fa-amazon', 'fab fa-android', 'fab fa-chrome',
        'fab fa-discord', 'fab fa-docker', 'fab fa-dropbox', 'fab fa-gitkraken',
        'fab fa-gitlab', 'fab fa-odnoklassniki', 'fab fa-python', 'fab fa-redhat',
        'far fa-bookmark', 'far fa-calendar-alt', 'far fa-calendar-check', 'far fa-eye',
        'far fa-chart-bar', 'far fa-eye-slash', 'fas fa-broadcast-tower', 'fas fa-bug',
        'fas fa-code', 'fas fa-coins', 'fas fa-hdd', 'fas fa-lock'
    ];

    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal modal-icon-picker">
                <header className="modal-header">
                    <h2>Escolha um Ícone</h2>
                    <button className="close-button" onClick={fecharModal}>&times;</button>
                </header>
                <div className="modal-body">
                    <div className="icon-grid">
                        {icons.map((icon, index) => (
                            <button
                                key={index}
                                className="modal-icon"
                                onClick={() => iconeSelecionado(icon)}
                            >
                                <FontAwesomeIcon icon={icon.split(' ')} className="modal-icon" />
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ModalPermissoesGrupo = ({ 
    show, 
    fecharModal,  
    getCookie, 
    showToast, 
    idGrupo,
    grupos,
    grupoId
    
}) => {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [showConfirmacao, setShowConfirmacao] = useState(false);

    useEffect(() => {
        if (show) {
            buscarUsuarios();
        }
    }, [show]);


    const buscarUsuarios = async () => {
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/buscarTodos`, {
                method: 'GET',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            
            if (result.status === "ok") {
                const usuariosFormatados = result.lista.map(usuario => ({
                    id: usuario.id || usuario._id,
                    nome: usuario.nome,
                    checked: "" // Inicialmente nenhum usuário está selecionado
                }));
                
                setUsuarios(usuariosFormatados);
            } else {
                showToast(result.mensagem || 'Erro ao buscar usuários', 'error');
            }
        } catch (error) {
            showToast('Erro ao buscar usuários. Verifique sua conexão ou permissões.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const togglePermissao = (usuarioId) => {
        setUsuarios(usuarios.map(usuario => 
            usuario.id === usuarioId 
                ? { ...usuario, checked: usuario.checked === "checked" ? "" : "checked" } 
                : usuario
        ));
    };

const salvarPermissoesGrupo = async (isConfirmed = false) => {
    if (!isConfirmed) {
        setShowConfirmacao(true); // Mostra o modal de confirmação
        return;
    }

    try {
        // Verificação adicional
        if (!grupoId) {
            showToast("ID do grupo inválido", "error");
            return;
        }

        const usuariosSelecionados = usuarios
            .filter(usuario => usuario.checked === "checked")
            .map(usuario => usuario.id);

        const token_autorizado = getCookie("info");
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/atualizarPermissoesGrupo`, {
            method: 'POST',
            headers: {
                'Authority': token_autorizado,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id_grupo: grupoId, // Usando diretamente o grupoId
                usuarios: usuariosSelecionados
            }),
        });

        const result = await response.json();
        console.log("showToast no ModalPermissoesGrupo:", typeof showToast);
        if (result.status === "ok") {
            console.log("showToast function:", showToast);
            showToast('Permissões atualizadas com sucesso!', 'direita');
            setTimeout(() => fecharModal(), 500);
        } else {
            showToast(result.mensagem || 'Erro ao atualizar permissões', 'error', 'direita');
        }
        
    } catch (error) {
        console.error('Erro:', error);
        showToast('Erro ao salvar permissões', 'error');
    }
};

    const filteredUsuarios = usuarios.filter(usuario =>
        usuario.nome.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            {show && (
                <>
                    <div className="modal-overlay" onClick={fecharModal}></div>
                    <div className="modal-permissoes">
                        <div className="modal-header">
                            <h3>Permissões para Todos os Registros do Grupo</h3>
                            <button onClick={fecharModal} className="btn-close-modal">
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Buscar usuários..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="search-input-permissao"
                            />
                        </div>
                        <div className="usuario-modal-body">
                            {loading ? (
                                <div className="loading-container">
                                    <p>Carregando usuários...</p>
                                </div>
                            ) : (
                                <>
                                    <div className="warning-banner">
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                        <span>Usuários selecionados terão acesso a TODOS os registros deste grupo</span>
                                    </div>
                                    <div className="usuarios-lista">
                                        {filteredUsuarios.length > 0 ? (
                                            filteredUsuarios.map(usuario => (
                                                <div key={usuario.id} className="usuario-item">
                                                    <label className="checkbox-container">
                                                        <input
                                                            type="checkbox"
                                                            checked={usuario.checked === "checked"}
                                                            onChange={() => togglePermissao(usuario.id)}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                    <div className="usuario-info">
                                                        <span className="usuario-nome">{usuario.nome}</span>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="no-results">Nenhum usuário encontrado</p>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button onClick={fecharModal} className="btn-cancelar">
                                Cancelar
                            </button>
                            <button 
                                onClick={() => salvarPermissoesGrupo()} 
                                className="btn-salvar"
                                disabled={loading}
                            >
                                <FontAwesomeIcon icon={faSave} /> Salvar
                            </button>
                        </div>
                    </div>
                    
                    {/* Modal de Confirmação */}
                    {showConfirmacao && (
                        <div className="modal-overlay">
                            <div className="confirmation-modal-permissoes">
                                <div className="modal-body">
                                    <div className="warning-confirm">
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                        <h4>Atenção!</h4>
                                    </div>
                                    <p>Ao confirmar, você está ciente de que os usuários selecionados poderão visualizar <strong>TODOS</strong> os registros deste grupo.</p>
                                    <p>Deseja continuar?</p>
                                </div>
                                <footer className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => setShowConfirmacao(false)}>Cancelar</button>
                                    <button className="btn btn-primary" onClick={salvarPermissoesGrupo}>Confirmar</button>
                                </footer>
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
};

const ConfirmationModal = ({ show, fecharModal, handleConfirm, message, additionalMessage }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal confirmation-modal">
                <div className="modal-body">
                    <p>{message}</p>
                    {additionalMessage && <p style={{ color: '#888', fontSize: '0.9em', marginTop: '10px' }}>{additionalMessage}</p>}
                </div>
                <footer className="modal-footer">
                    <button className="btn btn-secondary" onClick={fecharModal}>Cancelar</button>
                    <button className="btn btn-primary" onClick={handleConfirm}>Confirmar</button>
                </footer>
            </div>
        </div>
    );
};

const LogoutConfirmationModal = ({ show, fecharModal, handleConfirm }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="logout-confirmation-modal">
                <div className="modal-body">
                <p style={{ textAlign: 'center', color: 'white' }}>Tem certeza que deseja sair?</p>
                </div>
                <footer className="modal-footer">
                    <button className="btn btn-secondary" onClick={fecharModal}>Não</button>
                    <button className="btn btn-primary" onClick={handleConfirm}>Sim</button>
                </footer>
            </div>
        </div>
    );
};

const CartaoModal = ({ show, fecharModal, cartao }) => {

    const [tempoRestante, setTempoRestante] = useState(60); // 60 segundos

    useEffect(() => {
        let intervalo;
        let timeout;

        if (show && cartao) {
            setTempoRestante(60); // Reinicia o contador quando o modal abre

            intervalo = setInterval(() => {
                setTempoRestante((prev) => prev - 1);
            }, 1000);

            timeout = setTimeout(() => {
                fecharModal();
            }, 60000);
        }

        return () => {
            clearInterval(intervalo);
            clearTimeout(timeout);
        };
    }, [show, cartao]);

    if (!show || !cartao) return null;

    return (
        <div className="modal-overlay">
            <div className="modal cartao-modal">
                <header className="modal-header">
                    <h2>Detalhes do Cartão</h2>
                    <button className="close-button" onClick={fecharModal}>&times;</button>
                </header>
                <div className="modal-body">
                    <div className="form-group">
                        <label>Título</label>
                        <p>{cartao.titulo}</p>
                    </div>
                    
                    <div className="form-group">
                        <label>Número do Cartão</label>
                        <p>{cartao.numero}</p>
                    </div>
                    
                    <div className="form-group">
                        <label>CPF/CNPJ</label>
                        <p>{cartao.cpf || '-'}</p>
                    </div>
                    
                    <div className="form-group">
                        <label>Nome no Cartão</label>
                        <p>{cartao.nome || '-'}</p>
                    </div>
                    
                    <div className="form-group">
                        <label>Senha</label>
                        <p>{cartao.senha}</p>
                    </div>
                    
                    <div className="form-group-small">
                        <div className="form-group">
                            <label>Mês</label>
                            <p>{cartao.mes}</p>
                        </div>
                        
                        <div className="form-group">
                            <label>Ano</label>
                            <p>{cartao.ano}</p>
                        </div>
                        
                        <div className="form-group">
                            <label>CVV</label>
                            <p>{cartao.codigo || cartao.cvv || cartao.codigo_cartao || '•••'}</p>
                        </div>
                    </div>

                    <p className="contador-tempo">Este cartão será fechado em {tempoRestante} segundo{tempoRestante === 1 ? '' : 's'}...</p>
                
                </div>
            </div>
        </div>
    );
};

const VerificarAcessoModal = ({ 
    show, 
    fecharModal, 
    cancelarVerificacao, 
    verificarCodigo,
    titulo = "Verificação em duas etapas",
    descricao = "Insira o código de 6 dígitos do seu app de autenticação",
    textoBotaoConfirmar = "Verificar"
}) => {
    const [codigo, setCodigo] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleVerificar = () => {
        verificarCodigo(codigo, fecharModal, setIsLoading);
    };

    useEffect(() => {
        if (!show) {
            setCodigo("");
        }
    }, [show]);

    if (!show) return null;

    return (
        <div className="modal-verificacao-overlay">
            <div className="modal-verificacao">
                <div className="modal-content">
                    <div className="modal-title">{titulo}</div>
                    <div className="modal-description">{descricao}</div>
                    <input 
                        type="text" 
                        value={codigo} 
                        onChange={(e) => setCodigo(e.target.value)}
                        className="otp-input" 
                        maxLength="6" 
                        placeholder="••••••" 
                    />
                    <div className="modal-buttons">
                        <button 
                            className="btn-validacao btn-cancel-validacao" 
                            onClick={cancelarVerificacao}
                        >
                            Cancelar
                        </button>
                        <button 
                            className="btn-validacao btn-verify-validacao" 
                            onClick={handleVerificar} 
                            disabled={isLoading || codigo.length !== 6}
                        >
                            {isLoading ? <span className="spinner" /> : textoBotaoConfirmar}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const HistoricoModal = ({ show, fecharModal, historico, loading, showToast, getCookie}) => {
    const [showPasswordPopup, setShowPasswordPopup] = useState(false);
    const [passwordToShow, setPasswordToShow] = useState('');
    const [registroSelecionado, setRegistroSelecionado] = useState(null);
    const [loadingSenha, setLoadingSenha] = useState(false);
    const [showVerificarAcessoModal, setShowVerificarAcessoModal] = useState(false);
    const [acessoVerificado, setAcessoVerificado] = useState(false);
    const acaoPendenteRef = useRef(null);

    const verificarCodigo = (codigo, fecharModal, setIsLoading) => {
        // Sua função de validação OTP existente
        validarOTP(
            codigo,
            "validacao",
            () => {
                fecharModal();
                setAcessoVerificado(true);
                setIsLoading(false);
                
                if (acaoPendenteRef.current) {
                    acaoPendenteRef.current();
                    acaoPendenteRef.current = null;
                }
            },
            (erro) => {
                setIsLoading(false);
                showToast(erro || 'Código inválido', 'error');
            },
            setIsLoading
        );
    };

    const cancelarVerificacao = () => {
        setShowVerificarAcessoModal(false);
        setRegistroSelecionado(null);
        acaoPendenteRef.current = null;
        setAcessoVerificado(false);
    };

    const fetchSenhaHistorico = async (registroId) => {
        setLoadingSenha(true);
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/verChave?id=${registroId}&opcao=visualizar_senha_historico`, {
                headers: {
                    'Authority': token_autorizado,
                },
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const result = await response.json();
            
            if (result.status === "ok") {
                return result.chave;
            } else if (result.status === "bloqueado") {
                setShowVerificarAcessoModal(true);
                return null;
            } else {
                throw new Error(result.mensagem || 'Erro ao obter senha histórica');
            }
        } catch (error) {
            console.error('Erro ao buscar senha histórica:', error);
            showToast(error.message || 'Erro ao visualizar senha histórica', 'error');
            return null;
        } finally {
            setLoadingSenha(false);
        }
    };

    const handleShowPassword = async (registro) => {
        setRegistroSelecionado(registro);
        
        if (!acessoVerificado) {
            acaoPendenteRef.current = async () => {
                const senha = await fetchSenhaHistorico(registro._id);
                if (senha) {
                    setPasswordToShow(senha);
                    setShowPasswordPopup(true);
                }
            };
            setShowVerificarAcessoModal(true);
            return;
        }

        const senha = await fetchSenhaHistorico(registro._id);
        if (senha) {
            setPasswordToShow(senha);
            setShowPasswordPopup(true);
        }
    };

    const downloadArquivoComNome = async (url, novoNome) => {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error("Erro ao buscar o arquivo");
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = novoNome;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Falha no download:", error);
            showToast('Erro ao baixar o arquivo', 'error');
        }
    };

    if (!show) return null;

    return (
        <>
            <div className="modal-overlay historico-overlay">
                <div className='historico-modal-container'>
                    <div className='historico-modal-content'>
                        <div className="historico-modal-header">
                            <h3>Histórico de Alterações</h3>
                            <button onClick={fecharModal} className="close-button">&times;</button>
                        </div>
                        
                        <div className="historico-modal-body">
                            {loading ? (
                                <div className="loading-container">
                                    <p>Carregando histórico...</p>
                                </div>
                            ) : historico && historico.length > 0 ? (
                                <div className="table-container">
                                    <table className="historico-table">
                                        <thead>
                                            <tr>
                                                <th>Data/Hora</th>
                                                <th>Título</th>
                                                <th>Login</th>
                                                <th>Sistema</th>
                                                <th>Notas</th>
                                                <th>Senha</th>
                                                <th>Arquivo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {historico.map((item, index) => (
                                                <tr key={index}>
                                                    <td data-label="Data/Hora">{item.data} {item.hora}</td>
                                                    <td data-label="Título">{item.titulo}</td>
                                                    <td data-label="Login">{item.login || '-'}</td>
                                                    <td data-label="Sistema">{item.sistema || '-'}</td>
                                                    <td data-label="Notas">{item.notas || '-'}</td>
                                                    <td data-label="Senha" className="senha-cell">
                                                    {item.tem_senha === true && (
                                                        <FontAwesomeIcon 
                                                            icon={faEye} 
                                                            className={`icon ${loadingSenha ? 'loading-icon' : ''}`} 
                                                            onClick={() => handleShowPassword(item)} 
                                                            title="Visualizar senha histórica"
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    )}
                                                    </td>
                                                    <td data-label="Arquivo">
                                                        {item.hiperlink && item.nome_arquivo ? (
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span 
                                                                    className="arquivo-nome"
                                                                    onClick={() => downloadArquivoComNome(item.hiperlink, item.nome_arquivo)}
                                                                    style={{ cursor: 'pointer', marginRight: '8px' }}
                                                                    title={`Baixar ${item.nome_arquivo}`}
                                                                >
                                                                    {item.nome_arquivo}
                                                                </span>
                                                                <FontAwesomeIcon 
                                                                    icon={faDownload} 
                                                                    className="icon" 
                                                                    onClick={() => downloadArquivoComNome(item.hiperlink, item.nome_arquivo)}
                                                                    style={{ cursor: 'pointer' }}
                                                                    title={`Baixar o arquivo: ${item.nome_arquivo}`}
                                                                />
                                                            </div>
                                                        ) : '-'}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="no-history">
                                    <p>Nenhum histórico disponível para este registro.</p>
                                </div>
                            )}
                        </div>
                        
                        <div className='historico-modal-footer'>
                            <button
                                className='btn-close'
                                onClick={fecharModal}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <VerificarAcessoModal
                show={showVerificarAcessoModal}
                fecharModal={() => setShowVerificarAcessoModal(false)}
                cancelarVerificacao={cancelarVerificacao}
                verificarCodigo={verificarCodigo}
                titulo="Verificação necessária"
                descricao="Para visualizar senhas históricas, insira seu código de autenticação"
            />

            {showPasswordPopup && (
                <div className="password-popup-overlay senha-overlay">
                    <div className='password-popup'>
                        <div className='password-timer-bar' /> 
                        <div className='password-popup-content'>
                            <p>{passwordToShow}</p>
                            <div className='password-popup-buttons'>
                                <button
                                    className='btn-copy'
                                    onClick={() => {
                                        navigator.clipboard.writeText(passwordToShow);
                                        showToast('Senha copiada com sucesso!', 'success');
                                        setShowPasswordPopup(false);
                                    }}
                                >
                                    Copiar
                                </button>
                                <button
                                    className='btn-close'
                                    onClick={() => setShowPasswordPopup(false)}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const AdicionarUsuarioModal = ({ show, fecharModal, salvarUsuario, usuario = null, isEditing = false }) => {
    const [novoUsuario, setNovoUsuario] = useState({
        nome: '',
        email: '',
        cargo: 'user',
        status: 'ativo'
    });

    useEffect(() => {
        if (usuario) {
            setNovoUsuario({
                nome: usuario.nome,
                email: usuario.email,
                cargo: usuario.cargo,
                status: usuario.status,
                id : usuario.id
            });
        } else {
            setNovoUsuario({
                nome: '',
                email: '',
                cargo: 'user',
                status: 'ativo'
            });
        }
    }, [usuario]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNovoUsuario(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = () => {
        salvarUsuario(novoUsuario);
    };

    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal adicionar-usuario-modal">
                <header className="modal-header">
                    <h2>{isEditing ? "Editar Usuário" : "Adicionar Novo Usuário"}</h2>
                    <button className="close-button" onClick={fecharModal}>&times;</button>
                </header>
                <div className="adicionar-modal-body">
                    <div className="form-group">
                        <label>Nome Completo</label>
                        <input
                            type="text"
                            name="nome"
                            value={novoUsuario.nome}
                            onChange={handleInputChange}  
                            placeholder="Digite o nome completo"
                            required
                            maxLength={50}
                        />
                        <div className="character-counter">
                            {novoUsuario.nome.length}/50 caracteres
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <label>E-mail</label>
                        <input
                            type="email"
                            name="email"
                            value={novoUsuario.email}
                            onChange={handleInputChange}  
                            placeholder="Digite o e-mail"
                            required
                            maxLength={50}
                        />
                        <div className="character-counter">
                            {novoUsuario.email.length}/50 caracteres
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group half-width">
                            <label>Cargo</label>
                            <select
                                name="cargo"
                                value={novoUsuario.cargo}
                                onChange={handleInputChange}  
                                required
                            >
                                <option value="admin">Admin</option>
                                <option value="dev">Dev</option>
                                <option value="financeiro">Financeiro</option>
                                <option value="cs">CS</option>
                                <option value="mkt">MKT</option>
                                <option value="outros">Outros</option>
                            </select>
                        </div>

                        <div className="form-group half-width">
                            <label>Status</label>
                            <select
                                name="status"
                                value={novoUsuario.status}
                                onChange={handleInputChange}  
                                required
                            >
                                <option value="ativo">Ativo</option>
                                <option value="bloqueado">Bloqueado</option>
                            </select>
                        </div>
                    </div>
                </div>
                <footer className="modal-footer">
                    <button className="btn btn-secondary" onClick={fecharModal}>Cancelar</button>
                    <button className="btn btn-primary" onClick={handleSubmit}>Cadastrar</button>
                </footer>
            </div>
        </div>
    );
};

const UserProfileModal = ({ show, fecharModal, userData, handlePasswordChange, showToast, getCookie }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPasswordForm, setShowPasswordForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [acessoVerificado, setAcessoVerificado] = useState(false);
    const [showVerificarAcessoModal, setShowVerificarAcessoModal] = useState(false);
    const acaoPendenteRef = useRef(null);
    const [criterios, setCriterios] = useState({
        comprimento: false,
        maiusculas: false,
        minusculas: false,
        numeros: false,
        especiais: false,
        iguais: false
    });

    const verificarCriteriosSenha = (senha) => {
        return {
            comprimento: senha.length >= 8,
            maiusculas: /[A-Z].*[A-Z]/.test(senha),
            minusculas: /[a-z].*[a-z]/.test(senha),
            numeros: /\d.*\d/.test(senha),
            especiais: /[!@#$%&*()_;].*[!@#$%&*()_;]/.test(senha)
        };
    };

    const handleNewPasswordChange = (e) => {
        const senha = e.target.value;
        setNewPassword(senha);
        
        setCriterios(prev => ({
            ...verificarCriteriosSenha(senha),
            iguais: senha === confirmPassword && confirmPassword.length > 0
        }));
    };

    const handleConfirmPasswordChange = (e) => {
        const confirmacao = e.target.value;
        setConfirmPassword(confirmacao);
        
        setCriterios(prev => ({
            ...prev,
            iguais: newPassword === confirmacao && confirmacao.length > 0
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Verifica se todos os critérios foram atendidos
        const todosCriteriosAtendidos = Object.values(criterios).every(c => c);
        
        if (!todosCriteriosAtendidos) {
            showToast("Por favor, atenda a todos os requisitos de senha!");
            return;
        }
        
        if (newPassword !== confirmPassword) {
            showToast("As senhas não coincidem!");
            return;
        }
        
        setIsLoading(true);
        
        try {
            // Assumindo que `handlePasswordChange` retorna uma Promise ou usa callbacks
            await handlePasswordChange(currentPassword, newPassword);
            
            // Limpa os campos APENAS em caso de sucesso
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            setCriterios({
                comprimento: false,
                maiusculas: false,
                minusculas: false,
                numeros: false,
                especiais: false,
                iguais: false
            });
            
            showToast("Senha alterada com sucesso!", "success");
            setShowPasswordForm(false); // Fecha o formulário de senha (opcional)
        } catch (error) {
            showToast(error.message || "Erro ao alterar senha. Verifique sua senha atual.", "error");
            // NÃO limpa os campos em caso de erro
        } finally {
            setIsLoading(false); // Garante que o loading sempre pare
        }
    };

    const cancelarVerificacao = () => {
        setShowVerificarAcessoModal(false);
        acaoPendenteRef.current = null;
        setAcessoVerificado(false);
    };

    const verificarCodigo = (codigo, fecharModal, setIsLoading) => {
        // Sua função de validação OTP existente
        validarOTP(
            codigo,
            "validacao",
            () => {
                fecharModal();
                setAcessoVerificado(true);
                setIsLoading(false);
                
                if (acaoPendenteRef.current) {
                    acaoPendenteRef.current();
                    acaoPendenteRef.current = null;
                }
            },
            (erro) => {
                setIsLoading(false);
                showToast(erro || 'Código inválido', 'error');
            },
            setIsLoading
        );
    };

    const liberarIP = async () => {

        setIsLoading(true); 

        try {
            const token_autorizado = getCookie("info");

            const response_myip = await fetch("https://api.ipify.org?format=json");
            const data = await response_myip.json();

            if (!data.ip) throw new Error("Não foi possível obter seu IP.");

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/liberarAcesso`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    ip: data.ip
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            
            if (result.status === "finalizado") {
                const mensagens = result.resultado.map(res => {
                    const emoji = res.status === "ok" ? "✅" : "⚠️";
                    return `${emoji} ${res.mensagem} (${res.infra})`;
                }).join("\n"); 

                const tipo = result.resultado.some(r => r.status === "erro") ? "warning" : "success";

                showToast(mensagens, tipo);
            } else {
                showToast('Ocorreu algum erro', 'error');
            }
        } catch (error) {
            showToast("Erro ao liberar o IP. Tente novamente mais tarde.", "error");
        } finally {
            setIsLoading(false);
            setAcessoVerificado(false);
        }
    };

    const handleLiberarIp = async () => {

        if (!acessoVerificado) {
            acaoPendenteRef.current = async () => {
                await liberarIP();
            };

            setShowVerificarAcessoModal(true);
            return;
        }
        await liberarIP();
       
    };


    if (!show || !userData) return null;

    return (
        <div className="modal-overlay profile-modal-overlay">
            <div className="profile-modal-container">
                <div className="profile-modal-header">
                    <div className="profile-avatar">
                        {userData.nome.split(' ').filter(Boolean).length > 1 
                            ? `${userData.nome.split(' ')[0][0]}${userData.nome.split(' ').filter(Boolean).pop()[0]}`.toUpperCase()
                            : userData.nome[0].toUpperCase()}
                    </div>
                    <button className="profile-close-btn" onClick={fecharModal}>
                        &times;
                    </button>
                </div>
                
                <div className="profile-modal-body">
                    {!showPasswordForm ? (
                        <>
                            <div className="user-info-section">
                                <h3 className="profile-title">Meu Perfil</h3>
                                
                                <div className="info-card">
                                    <div className="info-item">
                                        <span className="info-icon">👤</span>
                                        <div className="info-content">
                                            <p className="info-label">Nome</p>
                                            <p className="info-value">{userData.nome}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="info-item">
                                        <span className="info-icon">✉️</span>
                                        <div className="info-content">
                                            <p className="info-label">Email</p>
                                            <p className="info-value">{userData.email}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="info-item">
                                        <span className="info-icon">💼</span>
                                        <div className="info-content">
                                            <p className="info-label">Cargo</p>
                                            <p className="info-value">{userData.cargo}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(userData?.cargo === "Admin" || userData?.cargo === "dev") && (
                                <button 
                                    className="profile-action-btn"
                                    onClick={handleLiberarIp}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <span className="btn-icon">⏳ Liberando IP...</span>
                                    ) : (
                                        <>
                                            <span className="btn-icon">🔁</span> Liberar meu IP
                                        </>
                                    )}
                                </button>
                            )}
                            
                            <button 
                                className="profile-action-btn"
                                onClick={() => setShowPasswordForm(true)}
                            >
                                <span className="btn-icon">🔒</span>
                                Alterar Senha
                            </button>
                        </>
                    ) : (
                        <>
                            <div className="user-info-section">
                                <h3 className="profile-title">Alterar Senha</h3>
                            </div>

                            <form onSubmit={handleSubmit} className="password-form">
                                <div className="input-group">
                                    <label className="input-label">Senha Atual</label>
                                    <input
                                        type="password"
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                        required
                                        maxLength={50}
                                        className="profile-input"
                                        placeholder="Digite sua senha atual"
                                    />
                                </div>
                                
                                <div className="input-group">
                                    <label className="input-label">Nova Senha</label>
                                    <input
                                        type="password"
                                        value={newPassword}
                                        onChange={handleNewPasswordChange}
                                        required
                                        className="profile-input"
                                        placeholder="Digite a nova senha"
                                        maxLength={50}
                                    />
                                </div>
                                
                                <div className="input-group">
                                    <label className="input-label">Confirmar Nova Senha</label>
                                    <input
                                        type="password"
                                        value={confirmPassword}
                                        onChange={handleConfirmPasswordChange}
                                        required
                                        className="profile-input"
                                        placeholder="Confirme a nova senha"
                                        maxLength={50}
                                    />
                                </div>

                                <div className='password-rules'>
                                    <ul className="checklist">
                                        <li className={criterios.comprimento ? "check" : ""}>
                                            {criterios.comprimento ? "✅" : "❌"} Pelo menos 9 caracteres
                                        </li>
                                        <li className={criterios.maiusculas ? "check" : ""}>
                                            {criterios.maiusculas ? "✅" : "❌"} Pelo menos 2 letras maiúsculas
                                        </li>
                                        <li className={criterios.minusculas ? "check" : ""}>
                                            {criterios.minusculas ? "✅" : "❌"} Pelo menos 2 letras minúsculas
                                        </li>
                                        <li className={criterios.numeros ? "check" : ""}>
                                            {criterios.numeros ? "✅" : "❌"} Pelo menos 2 números
                                        </li>
                                        <li className={criterios.especiais ? "check" : ""}>
                                            {criterios.especiais ? "✅" : "❌"} Pelo menos 2 caracteres especiais (!@#$%&*()_;)
                                        </li>
                                        <li className={criterios.iguais ? "check" : ""}>
                                            {criterios.iguais ? "✅" : "❌"} Senhas iguais
                                        </li>
                                    </ul>
                                </div>
                                
                                <div className="form-actions">
                                    <button 
                                        type="button" 
                                        className="profile-cancel-btn"
                                        onClick={() => setShowPasswordForm(false)}
                                        disabled={isLoading}
                                    >
                                        Voltar
                                    </button>
                                    <button 
                                        type="submit" 
                                        className="profile-save-btn"
                                        disabled={isLoading || !Object.values(criterios).every(c => c)}
                                    >
                                        {isLoading ? (
                                            <span className="loading-spinner"></span>
                                        ) : 'Salvar Alterações'}
                                    </button>
                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>

            <VerificarAcessoModal
                show={showVerificarAcessoModal}
                fecharModal={() => setShowVerificarAcessoModal(false)}
                cancelarVerificacao={cancelarVerificacao}
                verificarCodigo={verificarCodigo}
                titulo="Verificação necessária"
                descricao="Para liberar o IP, insira seu código de autenticação"
            />
        </div>
    );
};


export { 
    Modal, 
    ModalOpcoesIcone, 
    ConfirmationModal, 
    LogoutConfirmationModal, 
    CartaoModal, 
    VerificarAcessoModal, 
    HistoricoModal,
    AdicionarUsuarioModal, 
    UserProfileModal,
    ModalPermissoesGrupo // <-- Novo modal exportado
};

